export default "__VITE_ASSET__DXlVCnxf__";